module.exports = __webpack_public_path__ + "static/media/kozamgi_rwamiko1.c4580917.jpg";